<template>
  <v-tooltip
    v-if="hasNewAppLink"
    bottom
    color="info lighten-3"
    content-class="new-app-link-tooltip"
  >
    <template #activator="{ on, attrs}">
      <v-btn
        class="new-app-link-btn"
        outlined
        color="info"
        v-bind="attrs"
        v-on="on"
        @click="goToNewApp"
      >
        <v-icon class="mr-3">
          mdi-star
        </v-icon>
        <span>
          Switch to New Design
        </span>
      </v-btn>
    </template>
    <div class="new-app-link-text">
      View this page in our new look! Click the link to try it out and let us know what you think.
    </div>
  </v-tooltip>
</template>

<script>
export default {
  name: "NewAppLink",
  data() {
    return {
      routeMap: {
        "/accounts": "/accounts",
        "/api_tokens": "/api_tokens",
        "/blacklist": "/blacklist",
        "/bulk_unsubscribe": "/campaigns/bulk_unsubscribe",
        "/campaigns": "/campaigns/search",
        "/channels/banners": "/channel/banners",
        "/channels/email": "/campaigns/creatives",
        "/channels/email/:id": "/campaigns/creatives/:id",
        "/channels/email/create": "/campaigns/creatives",
        "/channels/events": "/channel/events_conferences",
        "/contacts": "/contacts/search/:searchId?",
        "/contacts/:id": "/contacts/:id",
        "/contacts/:id/edit": "/contacts/:id/edit",
        "/contacts/add": "/contacts/add",
        "/contacts/add/single": "/contacts/add_single",
        "/contacts/import": "/contacts/bulk_import",
        "/contacts/match": "/contacts/match_tool",
        "/dashboard": "/dashboard",
        "/dashboard/:id": "/dashboard/:id",
        "/dashboard/:id/edit": "/dashboard/:id/edit",
        "/exports": "/exports",
        "/fromlines": "/campaigns/fromlines",
        "/imports": "/imports",
        "/imports/:id/header_mapping": "/imports/:id/header_mapping",
        "/notifications": "/notification",
        "/personalization_settings/:id": "/personalization_settings/:id",
        "/plugins": "/plugins",
        "/plugins/install/notification/:id": "/plugins/install/notification/:id?",
        "/reports": "/reports",
        "/segments": "/segments/search",
        "/sources": "/source",
        "/user/profile": "/my_profile"
      }
    };
  },
  computed: {
    hasNewAppLink() {
      if (!process.env.VUE_APP_NEW_APP_URL) {
        return false;
      }

      return this.findRouteIndex() !== -1;
    }
  },
  methods: {
    findRouteIndex() {
      const matchedRoute = [...this.$route.matched].pop();

      if (!matchedRoute) {
        return -1;
      }

      return Object.values(this.routeMap).indexOf(matchedRoute.path);
    },
    findNewAppRoute() {
      const index = this.findRouteIndex();
      if (index === -1) {
        return null;
      }

      let newRoute = Object.keys(this.routeMap)[index];
      if (!newRoute) {
        return null;
      }

      for (let key in this.$route.params) {
        // Replace optional params first (":id?") to avoid leaving a trailing "?" behind.
        newRoute = newRoute.replace(':' + key + '?', this.$route.params[key]);
        newRoute = newRoute.replace(':' + key, this.$route.params[key]);
      }

      // Drop any still-unresolved params (e.g. optional params not provided)
      newRoute = newRoute
        .replace(/\/:[^/?#]+\?/g, "")
        .replace(/\/:[^/?#]+/g, "");

      const queryString = (new URLSearchParams(this.$route.query)).toString();

      if (queryString) {
        newRoute += '?' + queryString;
      }

      return newRoute;
    },
    goToNewApp() {
      window.location = process.env.VUE_APP_NEW_APP_URL.replace(/\/+$/, '') + this.findNewAppRoute();
    }
  }
}
</script>

<style>
  .new-app-link-tooltip {
    opacity: 1 !important;
  }

  .new-app-link-btn {
    text-transform: none;
  }

  .new-app-link-text {
    color: #000;
  }
</style>
